import { baseApi } from 'services/baseApi';
import { LocalStorageService } from 'services';
import { saveResourceCurrenciesPrecisions } from 'app/resource/slices';
import { AppConstants } from 'constants/index';
import { Meta } from 'types';
import { CurrenciesPrecisions } from 'app/resource/types/currenciesPrecisions';

export const currenciesPrecisions = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getResourceCurrenciesPrecisions: builder.query<CurrenciesPrecisions, Meta>({
      query: ({ skipGlobalLoading } = {}) => {
        const { BrandAdmin, Currency, Precisions } = AppConstants.api;
        return {
          url: [BrandAdmin, Currency, Precisions],
          meta: { skipGlobalLoading },
        };
      },
      async onQueryStarted(arg: Meta, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;
        dispatch(saveResourceCurrenciesPrecisions(data));
        LocalStorageService.set('currenciesPrecisions', data);
      },
    }),
  }),
});

export const { useLazyGetResourceCurrenciesPrecisionsQuery } = currenciesPrecisions;
